import { Injectable } from "@angular/core";
import { RoleBasedParamModel } from "../models/role-based-param.model";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { UserAuthService } from "../services/user-auth.service";

@Injectable({
	providedIn: 'root',
})
export class RoleGuard {

	constructor(
		private readonly router: Router,
		private readonly userAuthService: UserAuthService
	) { }

	async canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {
		const requiredRoles = route.data['requiredRoles'] as string[] | undefined;

		if (!this.userAuthService.isAuthenticated()) {
			return this.router.parseUrl('/not-authorized');
		}

		if (requiredRoles && requiredRoles.length > 0) {
			const hasRoleAccess = await this.hasRoles(requiredRoles);

			if (!hasRoleAccess) {
				return this.router.parseUrl('/not-authorized');
			}
		}

		return true;
	}

	async hasRole(role: string): Promise<boolean> {
		const adGroups = await this.userAuthService.getAdGroups();

		return adGroups.includes(role);
	}

	async hasRoles(roles: string[]): Promise<boolean> {
		if (!roles || roles.length === 0) return true;


		const adGroups = await this.userAuthService.getAdGroups();

		// Check ANY role match
		return roles.some(r => adGroups.includes(r));
	}

	async hasCustomAccess(param: RoleBasedParamModel): Promise<boolean> {
		if (!this.userAuthService.isAuthenticated()) return false;

		let customRoleAccess = true;
		let pathRoleAccess = true;

		if (param.customRole?.length > 0) {
			customRoleAccess = await this.hasRoles(param.customRole);
		}

		if (param.path) {
			pathRoleAccess = await this.hasRoles([param.path]);
		}

		return customRoleAccess && pathRoleAccess;
	}
}